import { LorebookVisibility, ModerationStatus } from "@next-platform/packages-ts-types";
/**
 * True when an attached lorebook is not being applied in chat, so the creator should be told it is
 * temporarily unavailable.
 *
 * Same rule as the API's chat gate (`isLorebookFlaggedAndNotPublic`). `FixRequired` means a moderator read
 * the content and rejected it, and `RereviewRequired` is only reached from it, so the rejected content may
 * still be on the row. A lorebook waiting on a first-time public review keeps applying in the chatbots it
 * is already attached to, and must not be flagged here. `visibility` is the discriminator for "was approved at least
 * once", because a first-time submission stays non-public until an admin approves it: a PUBLIC lorebook
 * keeps serving its last approved version and is never unavailable.
 */
const isAttachedLorebookTemporarilyUnavailable = (lorebook) => {
    if (!lorebook)
        return false;
    const moderationStatus = lorebook.moderationReportStatus ?? lorebook.moderationReport?.moderation_status;
    if (moderationStatus !== ModerationStatus.FixRequired && moderationStatus !== ModerationStatus.RereviewRequired) {
        return false;
    }
    return lorebook.visibility !== LorebookVisibility.PUBLIC;
};
export default isAttachedLorebookTemporarilyUnavailable;
